
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Slide } from "shared-alva/models";
import OsdiTextField from "shared-alva/components/inputs/OsdiTextField.vue";
import MediaBlock from "@/components/sublessons/blocks/MediaBlock.vue";

@Component({
  components: {
    OsdiTextField,
    MediaBlock,
  },
})
export default class SlideImage extends Vue {
  @Prop()
  slide!: Slide;

  @Prop()
  sublessonId!: string;
}
